export const generateNodeName = (type) => {
  return `${type}_${Math.random().toString(36).substring(2, 15)}`;
};
